import { localizationService } from '@shared-services/localization-service';
import React from 'react';
import strings from '../../../strings';
import {
    BookerContextType,
    CalEventData,
    CalEventDataWithDisplayPrice,
    EventServerModel,
} from '../../../types';
import { getFormattedPriceStr } from '../../../utils';
import {
    Card,
    CardContent,
    EventDescription,
    EventDuration,
    EventPrice,
    EventTitle,
    MainContent,
} from '../common/styles';

interface EventCardProps extends EventServerModel {
    calEventData?: CalEventData;
    isLoading: boolean;
    onSelect: (event: CalEventDataWithDisplayPrice) => void;
}

const { str } = localizationService;

const EventCard: React.FC<EventCardProps> = ({
    identifier,
    slug,
    calEventData,
    priceInfo,
    onSelect,
}) => {
    if (!calEventData) {
        return null;
    }

    const price = getFormattedPriceStr({
        currentEvent: { priceInfo },
    } as BookerContextType);

    const handleSelect = () =>
        onSelect({
            ...calEventData,
            displayPrice: price,
        });

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleSelect();
        }
    };

    return (
        <Card
            role='listitem'
            onClick={handleSelect}
            onKeyDown={handleKeyDown}
            tabIndex={0}
            data-auto={`event-card-${slug}`}
            data-event-id={identifier}
            aria-label={`Select ${calEventData.title}, ${calEventData.lengthInMinutes} minutes, ${price}`}
        >
            <CardContent>
                <MainContent>
                    <EventTitle>{calEventData.title}</EventTitle>
                    {!!calEventData.description && (
                        <EventDescription>
                            {calEventData.description}
                        </EventDescription>
                    )}
                    <EventDuration>
                        {str(strings.durationMinutes, {
                            duration: calEventData.lengthInMinutes.toString(),
                        })}
                    </EventDuration>
                </MainContent>
                <EventPrice>{price}</EventPrice>
            </CardContent>
        </Card>
    );
};

export default EventCard;
